import React, { useState, useMemo } from 'react';
import Style from './Portfolio.module.scss';
import ProjectCard from './ProjectCard';
import ProjectModal from './ProjectModal';
import { projectsData } from '../../data/projectsData';

export default function Portfolio({ darkMode = false }) {
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [selectedProject, setSelectedProject] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Get unique categories
    const categories = useMemo(() => {
        const cats = new Set(projectsData.map(p => p.category));
        return ['All', ...Array.from(cats).sort()];
    }, []);

    // Filter projects based on selected category
    const filteredProjects = useMemo(() => {
        if (selectedCategory === 'All') {
            return projectsData;
        }
        return projectsData.filter(p => p.category === selectedCategory);
    }, [selectedCategory]);

    const handleViewDetails = (project) => {
        setSelectedProject(project);
        setIsModalOpen(true);
    };

    return (
        <section className={`${Style.portfolio} ${darkMode ? Style.dark : Style.light}`}>
            {/* Section Header */}
            <div className={Style.header}>
                <div className={Style.headerContent}>
                    <h2 className={Style.title}>Featured Projects</h2>
                    <p className={Style.subtitle}>
                        A selection of enterprise-grade systems and products I've engineered
                    </p>
                </div>
            </div>

            {/* Category Filter */}
            <div className={Style.filterSection}>
                <div className={Style.filterContainer}>
                    {categories.map((category) => (
                        <button
                            key={category}
                            className={`${Style.filterBtn} ${
                                selectedCategory === category ? Style.active : ''
                            }`}
                            onClick={() => setSelectedCategory(category)}
                        >
                            {category}
                            {selectedCategory === category && (
                                <div className={Style.underline} />
                            )}
                        </button>
                    ))}
                </div>
            </div>

            {/* Projects Grid */}
            <div className={Style.grid}>
                {filteredProjects.map((project) => (
                    <ProjectCard
                        key={project.id}
                        project={project}
                        onViewDetails={handleViewDetails}
                    />
                ))}
            </div>

            {/* Empty State */}
            {filteredProjects.length === 0 && (
                <div className={Style.emptyState}>
                    <p>No projects found in this category</p>
                </div>
            )}

            {/* Project Modal */}
            <ProjectModal
                project={selectedProject}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </section>
    );
}